import { useAuth } from "./AuthContext";
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // If auth is still loading, render nothing (or a loader)
  if (loading) return null;
  return user?.email === 'smmanik0075@gmail.com' ? children : <Navigate to="/admin_login" />;
};

export default ProtectedRoute;